import store from '@/store'

const { body } = document
const WIDTH = 1200 // Bootstrap 响应临界

export default {
  watch: {
    $route(route) {
      // if (this.device === 'mobile' && this.sidebar.opened) {
      //   store.dispatch('app/closeSideBar', { withoutAnimation: false })
      // }
    }
  },
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  mounted() {
    const isMobile = this.$_isMobile()
    // if (isMobile) {
    //   store.dispatch('app/toggleDevice', 'mobile')
    //   store.dispatch('app/closeSideBar', { withoutAnimation: true })
    // }
    if (isMobile) {
      store.dispatch('app/closeSideBar', { withoutAnimation: false })
    } else {
      store.dispatch('app/openSideBar', { withoutAnimation: false })
    }
  },
  methods: {
    $_isMobile() {
      try {
        const rect = body.getBoundingClientRect()
        return rect.width < WIDTH
      } catch (e) {
        return false
      }
    },
    $_resizeHandler() {
      // console.log('aaa')
      if (!document.hidden) {
        const isMobile = this.$_isMobile()
        // store.dispatch('app/toggleDevice', isMobile ? 'mobile' : 'desktop')

        if (isMobile) {
          store.dispatch('app/closeSideBar', { withoutAnimation: false })
        } else {
          store.dispatch('app/openSideBar', { withoutAnimation: false })
        }
      }
    }
  }
}
